 
	import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';    
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import InstrutorService from   "@/service/v1/sigap/InstrutorService"  
    import AulaService from   "@/service/v1/sigap/AulaService"  
    import { Options  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import KDataTable from   "@/components/datatable/newdatatable.vue" 
	import $ from "jquery";   
    import AlunosPdf from   "./_AlunosPdf.vue";
    import AulaPdf from   "./_PdfAula.vue";
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import Multiselect from '@vueform/multiselect'  
    
    @Options({
        name: "InstrutorIndexAulas",
        components: {  CardRh , KDataTable , AulaPdf , AlunosPdf, Multiselect },   
    }) 
    export default class InstrutorIndexAulas extends IndexModelTable {
        
        public instrutor: any = null; 
        public instrutorService = new InstrutorService(); 
        public status_id: any = 1
        public status: any = null; 
        public pelotao: any = null;
        public data_min: any = null;
        public data_max: any = null;

        public modal_pdf = 'modal_pdf_aula_professor'; 
        public id_pdf : any = null;


        get titulo( ): string {
            let texto = 'Aulas';
            if(this.instrutor) 
                texto = texto +  ' - ' + this.instrutor.disciplina.descricao ;
            if(this.instrutor && this.instrutor.turma) 
                texto = texto +   ' (' + this.instrutor.turma.descricao + ')' ;
            return texto;
        }

        get status_select(){
            if(this.status){
                return this.status.map((item) => { return { value:  item.id , label: item.nome } });   
            }
            return null;
        }
        
        public getStatus(){   
            this.processando = true ; 
            this.service.getStatus(    ) 
            .then(response => {   
                this.status =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 

        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.Professor ] ,  this.perfis); 
        }

        public refreshTable(){ 
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable ; 
            }, 300); 
        }
         
        public apertouEnter(e){ 
            if(e.key === 'Enter' || e.keyCode === 13){
                this.refreshTable();
            }
        }
           
        get hasPermissaoInstrutor( ): boolean {
            return this.instrutor && this.instrutor.usuarioId == this.currentUser.id; 
        }

        async created(){   
            this.service = new AulaService();  
            this.getStatus(); 
            this.config.ajax = { 
                url: this.service.getApiUrl() + "/GetAllAulaProfessor" ,
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length,
                        "DataMin": () => (document.querySelector('[data-kt-docs-table-filter="DataMin"]')! as HTMLInputElement).value ,
                        "DataMax": () => (document.querySelector('[data-kt-docs-table-filter="DataMax"]')! as HTMLInputElement).value , 
                        "instrutorCPF": () => (document.querySelector('[data-kt-docs-table-filter="instrutorCPF"]')! as HTMLInputElement).value , 
                        "instrutorId": () => (document.querySelector('[data-kt-docs-table-filter="instrutorId"]')! as HTMLInputElement).value , 
                        "status": () => (document.querySelector('[data-kt-docs-table-filter="StatusAula"]')! as HTMLInputElement).value , 
                        "pelotao": () => (document.querySelector('[data-kt-docs-table-filter="pelotao"]')! as HTMLInputElement).value , 
                        "numero": () => (document.querySelector('[data-kt-docs-table-filter="numero"]')! as HTMLInputElement).value , 
                        "search": d.search.value
                    }
                    return dados; 
                } 
            }; 

            this.config.columns = [ 
                { data:  'id',  name:  'id', searchable: false }, 
                { data:  'numero',  name:  'numero',  class: 'desktop' ,orderable: false, searchable: false }, 
                { data: 'aulaDisciplina', name: 'auladisciplina' , searchable: false}, 
                { data:  'data',  name:  'data', class:'desktop' , searchable: false}, 
                { data:  'inicio',  name:  'inicio', class:'desktop' , searchable: false}, 
                { data:  'fim',  name:  'fim', class:'desktop' , searchable: false}, 
                { data:  'status',  name:  'status' ,   searchable: false, class: 'text-center desktop'}, 
            ];
            this.config.columnDefs = [ 
                {
                    targets: 1,
                    render: function ( row, type, val, meta ) {  
                        return row +  '/' + (val.disciplina?.cargaHoraria ?? "")  ;  
                    }
                },  
                {
                    targets: 2,
                    render: function ( row, type, val, meta ) {   
                        return row != null ? row.pelotao : '';  
                    }
                },  
                {
                    targets: 3,
                    render: function ( row, type, val, meta ) {  
                        return SiteUtils.formatData( row )  ;
                    }
                },  
                {
                    targets: 6 ,
                    render: ( row, type, val, meta ) => {   
                        return row.nome ?? '';  
                    }, 
                } 
            ];
            if(this.hasPermissao){ 
                this.config.columns.push({ data: 'id', name: 'id'  , orderable: false, searchable: false , class: 'text-center' });
                this.config.columnDefs.push(
                    {
                        targets: 7 ,
                        render: ( row, type, val, meta ) => {  
                            let texto = '' ; 
                            let buttom = '' ;  
                            for (var key in val) {  buttom = buttom + ' data-' + key + '="'+ val[key] +'"'  } 
                            texto = texto + '<button class="btn btn-secondary btn-sm border border-pmes-danger" btn-pdf'+ buttom +'   data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_pdf  + '" title="Pdf"><i class="fa fa-2x fa-file-pdf text-pmes-danger"></i></button>';  

                            if(val.status.id == 1  ){
                                texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-homologar '+ buttom +' title="Homologar"><i class="fa fa-gavel"></i></button>';  
                            } 
                            return texto;  
                        }, 
                    }
                );  
            }
            await this.buscaInstrutor();
        }   
        
        
        public async buscaInstrutor( ) {
            this.processando = true ;  
            await this.instrutorService.getModel(this.$route.params.instrutor ) 
            .then(response => {    
                this.instrutor =  JSON.parse(JSON.stringify( response ));  
                this.pelotao = this.instrutor.pelotao
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            });  
        }
  
        public tableatualizada( event ) {   
            $('[btn-homologar]').click(  (btn) => {   
                let aula_id =   $(btn.currentTarget).data('id');   
                this.$router.push({ name: "instrutor_disciplina_aulas_validacao" ,   params: {  instrutor: this.instrutor.id , aula: aula_id  }  }) 
            });  

            $('[btn-pdf]').click(  (btn) => {   
                this.id_pdf =   null;
                setTimeout(() => {
                    this.id_pdf =   this.modelo != null ? this.modelo.id : null; 
                }, 100); 
            });  

        }  
 
        public selectModel( event ) {  
            this.modelo =   null; 
            this.modelo = event;
        }  

    } 
